import { useMemo } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import EmptyState from "@/components/feature/EmptyState";
import { formatCount } from "@/utils/format";
import { videos } from "@/mocks/videos";

export default function TrendingRanking() {
  const trending = useMemo(
    () => [...videos].sort((a, b) => b.views - a.views).slice(0, 8),
    []
  );

  return (
    <section className="lg:sticky lg:top-24">
      <SectionHeading title="热门视频榜单" subtitle="近期播放量最高的内容" />
      {trending.length === 0 ? (
        <EmptyState message="暂无相关内容，敬请期待" />
      ) : (
        <ol className="rounded-lg border border-background-200 bg-background-50 divide-y divide-background-200 overflow-hidden">
          {trending.map((video, index) => (
            <li key={video.id}>
              <Link
                to={`/detail/${video.id}`}
                className="flex items-center gap-3 px-3 py-3 hover:bg-background-100 transition-colors"
              >
                <span
                  className={`w-6 text-center text-sm font-heading font-bold shrink-0 ${
                    index < 3 ? "text-primary-600" : "text-foreground-400"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="relative w-24 aspect-video shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={video.cover}
                    alt={video.title}
                    title={`${video.title} - 樱桃视频`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-foreground-800 line-clamp-2 leading-snug">
                    {video.title}
                  </p>
                  <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                    <span>{video.categoryName}</span>
                    <span className="flex items-center">
                      <i className="ri-fire-line mr-0.5 text-accent-500"></i>
                      {formatCount(video.views)}
                    </span>
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}